import React from 'react';
import CircleSlider from '../components/CircleSlider';
import Div from '../components/Div.styled';
import QuestionContentWrapper from '../components/QuestionContentWrapper';
import useMediaQuery from '../hooks/useMediaQuery';
import useQuestionStore from '../store/navigation';
import {useResultStore} from '../store/responses';
import {sendAnalyticPayload} from '../utils/analytic';
import {QuestionData} from '../constants/questions';

import {QUESTIONIDS, SliderQuestion} from '../types/question';
import {useSpring, animated} from 'react-spring';
import TypographyBody from '../components/Typography/TypographyBody';

function QuestionThirteen(props: SliderQuestion) {
  const {nextStepId, title, min, max, label, increment} = props;
  const {setCurrentQuestion, currentQuestion} = useQuestionStore();
  const {updateQuestion, result} = useResultStore();
  const resultData = (result[currentQuestion] as number) || 43;
  const [value, setValue] = React.useState(resultData);

  function onChange(value: number) {
    setValue(value);
  }

  function onClickNext() {
    setCurrentQuestion(nextStepId);
    updateQuestion({
      id: currentQuestion as typeof QUESTIONIDS.questionTwelveTravelDistance,
      value: value,
    });
    sendAnalyticPayload({
      process: {
        StepName: currentQuestion,
        StepNumber:
          QuestionData[currentQuestion]?.progressValue.toString() ?? '',
      },
      question: [
        {
          Question: currentQuestion,
          Answer: [
            {
              value: value.toString(),
              type: 'slider',
            },
          ],
        },
      ],
    });
  }
  const springs = useSpring<React.CSSProperties>({
    from: {opacity: 0},
    to: {opacity: 1},
    delay: 500,
    config: {
      duration: 500,
    },
  });
  const {isMobile} = useMediaQuery();
  return (
    <QuestionContentWrapper
      title={title}
      handleClick={onClickNext}
      label={
        <animated.div style={{...springs}}>
          <TypographyBody
            size="small"
            style={{
              marginTop: 28,
            }}
            textAlign="center"
          >
            For reference, the average Aussie travels 40km a day
          </TypographyBody>
        </animated.div>
      }
    >
      <Div padding="20px 0">
        <CircleSlider
          increment={increment}
          label={label}
          min={min}
          max={max}
          initialValue={resultData + 1}
          onChange={onChange}
          width={isMobile ? 200 : 250}
        />
      </Div>
    </QuestionContentWrapper>
  );
}

export default QuestionThirteen;
